/**
 * @generated SignedSource<<9fef40e99c538e6e0bb8966723925640>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerPreQuotedOptions_deliveryOptions$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOption_shipmentQuote">;
  readonly " $fragmentType": "BuyerPreQuotedOptions_deliveryOptions";
}>;
export type BuyerPreQuotedOptions_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: BuyerPreQuotedOptions_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOptions_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BuyerPreQuotedOptions_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerPreQuotedOption_shipmentQuote"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "1ad4c850fb98c414cb75f37ce4e515c8";

export default node;
